// The index page (consistency-pass spec §2): Overview and the two lists.
// One header — title, one-line description, the primary action — then the
// page's own content. A list passes `fill`, so its table takes the rest of
// the viewport and scrolls its own rows: `main` has a definite height (flex-1
// inside the h-screen shell), so an h-full child fits exactly. Same shape as
// the vouchers admin's crud-page.

import { PageHead } from "@pej/kore/components";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export interface IndexPageProps {
    title: string;
    description?: string;
    action?: ReactNode;
    /** The content fills the remaining height (lists); otherwise the page grows and scrolls. */
    fill?: boolean;
    children: ReactNode;
}

export function IndexPage({ title, description, action, fill = false, children }: IndexPageProps) {
    return (
        <div className={cn("flex flex-col gap-6", fill ? "h-full" : "pb-6")}>
            <PageHead size="h1" title={title} description={description} action={action} />
            {children}
        </div>
    );
}
